export default {
    path: '/Prepaid',
    meta: {
        title: '电表充值',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/Prepaid`),
}


// WEBPACK FOOTER //
// ./src/views/Prepaid/router.js